module.exports = __webpack_public_path__ + "img/brochures.23593cf7.svg";